export function isNumber(value) {
  return /^\d+$/.test(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.17@vant/es/utils/validate/number.js
// module id = null
// module chunks = 